import { apiUrl } from "@/utils/helpers";
import axios from "axios";

const initiatePaymentPath = "/api/payments/startdirectcoursepayment";
const verifyPaymentPath = "/api/payments/verifydirectcoursepayment";

interface InitiatePaymentPayload {
  type: string;
  planArray: {
    plan_id?: string;
    offer_id?: string;
  }[];
  name: string;
  email: string;
  amount: number;
  mobile: string;
  plan_id?: string;
  applied_extra_offers?: string[];
  gst_details: {
    gst_provided_by_user_at_time_of_purchase: boolean;
    gstin: string;
    company_name: string;
  } | null;
}

interface VerifyPaymentPayload {
  receipt_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
  razorpay_order_id: string;
}

export const initiatePayment = async (payload: InitiatePaymentPayload) => {
  const data = await axios.post(apiUrl(initiatePaymentPath), payload);

  return data;
};

export const verifyPayment = async (payload: VerifyPaymentPayload) => {
  const data = await axios.post(apiUrl(verifyPaymentPath), payload);

  return data;
};
